import React from 'react'
import styles from './s.module.css'

export default class OdInput extends React.Component {
  constructor (props) {
    super(props)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleSelect (dataObj) {
    this.props.onChange({
      target: {
        value: dataObj.od
      }
    })
    this.setState({
      selectorOn: false
    })
  }

  render () {
    const { value, onChange } = this.props
    return (
      <div className={styles.odIn}>
        <div className={styles.inCon}>
          <label htmlFor='dn1'>Vnější profil:</label>
          <input type='text' id='dn1' value={value} onChange={onChange} />
          <label>m</label>
        </div>
      </div>
    )
  }
}

// OdInput.propTypes = {
//   value: PropTypes.string,
//   onChange: PropTypes.func,
//   useSelector: PropTypes.bool
// }

